enum ProgressTypes {
  OUTPUT = "output",
  REJECT = "reject",
  SETUP = "setup",
  TROUBLE = "trouble",
  TIME = "time"
}

export default ProgressTypes
